// extracted by mini-css-extract-plugin
export default {"root":"ProductCard_root__YtvVH","chips":"ProductCard_chips__o5f4q","buttons":"ProductCard_buttons__OJ9W-","inactive":"ProductCard_inactive__DLLwb"};